import type { PruefungDto } from '@/shared/Pruefungen/types/pruefung.ts';
import { HttpService } from '@/shared/api/services/HttpService.ts';
import { buildUrlForServiceName } from '@/connection/url-retriever.ts';
import conf from '@/shared/config/useConfig';

export class PruefungenService extends HttpService {
  protected pruefungenServiceBaseUrl = `${buildUrlForServiceName(
    conf.bürgschaftserviceName,
  )}/buergschaftservice/api/private/v1/pruefungen`;

  async holePruefentscheidungenZuBuergschaftId(buergschaftId: number): Promise<PruefungDto[]> {
    return this.httpClient.get(`${this.pruefungenServiceBaseUrl}/${buergschaftId}/entscheidungen`);
  }

  async pruefungLoeschen(): Promise<void> {
    throw new Error('Not implemented');
  }

  async pruefungAblehnen(): Promise<void> {
    throw new Error('Not implemented');
  }

  async istNutzerLetzterPruefer(
    id: string | number,
    type: 'auftrag' | 'buergschaft',
  ): Promise<boolean> {
    return this.httpClient.get(
      `${this.pruefungenServiceBaseUrl}/${id.toString()}/${type}/letzter-pruefer`,
    );
  }
}
